import { string } from 'yup';

import { isUnderSixteen } from '@becollective/utils';

export const dobAtLeast16 = string()
  .nullable()
  .required('Date of birth is required')
  .test(
    'is-at-least-16',
    'You must be at least 16 years of age or older',
    date => (date ? !isUnderSixteen(date) : false),
  );

export const dobUnder16 = string()
  .nullable()
  .required('Date of birth is required')
  .test(
    'is-under-16',
    'A child must be under 16 years of age',
    date => (date ? isUnderSixteen(date) : false),
  );
